document.addEventListener('DOMContentLoaded', function () {
  // 创建 IntersectionObserver 实例
  window.YGImageLoader = new IntersectionObserver((entries, observer) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        const img = entry.target;
        const newImg = new Image();
        newImg.onload = () => {
          img.src = newImg.src;
          img.removeAttribute('data-src');  // 如果只需要加载一次
          img.removeAttribute('srcset');
          observer.unobserve(img);          // 停止观察该元素
        }
        newImg.src = img.getAttribute('data-src');
      }
    });
  }, {
    rootMargin: "50px", // 预加载距离视口 50px 的图片
  });

  class YGImage extends HTMLElement {
    constructor() {
      super()
      this.init()
    }
    init () {
      // 这里放置初始化逻辑
      this.loaderImg()
    }

    get images () {
      return this.querySelectorAll('img[data-src]')
    }

    loaderImg () {
      // 这里放置自定义逻辑
      this.images.forEach((img) => {
        window.YGImageLoader.observe(img)
      })
    }
  }
  if (!window.customElements.get('yg-image')) {
    window.customElements.define('yg-image', YGImage)
  }

  class YGPopupBox extends HTMLElement {
    constructor() {
      super();
      this.addEventListener('click', (e) => {
        this.closePopup(e, () => { });
      });
    }

    openPopup ($popupTemplate, fn) {
      // popupTemplate：需要替换的元素
      this.querySelector('.yg-popup-box-content-inner').innerHTML = $popupTemplate.innerHTML;
      document.querySelector('body').style.overflow = 'hidden';
      this.style.display = 'flex';
      fn();
    }
    closePopup (e, fn) {
      if (e.target.className == 'yg-popup-box-close' || e.target.className == 'yg-popup-box') {
        this.style.display = 'none';
        this.querySelector('.yg-popup-box-content-inner').innerHTML = '';
        document.querySelector('body').style.overflow = 'auto';
        fn();
      }
    }
  }
  if (!window.customElements.get('yg-popup-box')) {
    window.customElements.define('yg-popup-box', YGPopupBox);
  }

  class YGOpenPopup extends HTMLElement {
    constructor() {
      super();
      this.init();
      this.$popupBox = document.querySelector('yg-popup-box.yg-popup-box');
    }
    init () {
      // 这里放置初始化逻辑
      this.addEventListener('click', this.itemClick.bind(this));
    }
    itemClick () {
      // 这里放置自定义逻辑
      let $popupTemplate = this.querySelector('template') || this.querySelector('.yg-popup-template');

      $popupTemplate && this.$popupBox.openPopup($popupTemplate, () => { });

    }
  }
  if (!window.customElements.get('yg-open-popup')) {
    window.customElements.define('yg-open-popup', YGOpenPopup);
  }

  class YGSwiper extends HTMLElement {
    constructor() {
      super()
    }
    connectedCallback () {
      this.getAllAttributes()
      this.initSwiper()
    }

    get getCurrentSlidesPerView () {
      if (!this['breakpoints']) return 1;

      const screenWidth = window.innerWidth;

      // 将breakpoints按数值从小到大排序
      const sortedKeys = Object.keys(this['breakpoints']).map(Number).sort((a, b) => a - b);

      let current = sortedKeys[0]; // 默认取最小的

      // 遍历找到小于等于当前屏幕宽度的最大key
      for (let i = 0; i < sortedKeys.length; i++) {
        if (screenWidth >= sortedKeys[i]) {
          current = sortedKeys[i];
        } else {
          break;
        }
      }

      return this['breakpoints'][current].slidesPerView;
    }

    getAllAttributes () {
      let booleanAttrs = ['loop', 'pagination', 'navigation', 'scrollbar', 'centered-slides'];
      let jsonAttrs = ['breakpoints']
      for (const attr of this.attributes) {
        if (attr.name.startsWith('data-')) {
          const cleanName = attr.name.slice(5); // 去除 'data-' 前缀

          let value = attr.value;
          if (booleanAttrs.includes(cleanName)) {
            value = value === 'true';
          } else if (jsonAttrs.includes(cleanName)) {
            value = this.parseSwiperBreakpoints(value);
          }

          this[cleanName] = value;
        }
      }
    }

    parseSwiperBreakpoints (str) {
      const result = {};
      const pairs = str.split(',');

      for (const pair of pairs) {
        const [breakpoint, values] = pair.split(':');
        if (!breakpoint || !values) continue;

        const [slides, space] = values.split('-').map(Number);

        result[breakpoint.trim()] = {
          slidesPerView: slides,
          spaceBetween: space
        };
      }

      return result;
    }

    initSwiper () {
      const swiper = new Swiper(this, {
        // 这里放置 swiper 的配置
        effect: this['effect'],
        loop: this['loop'],
        centeredSlides: this['centered-slides'],
        autoplay: this['autoplay'] ? {
          delay: this['autoplay'],
          stopOnLastSlide: false,
          disableOnInteraction: false,
          pauseOnMouseEnter: false,
        } : false,
        pagination: this['pagination'] ? {
          el: '.swiper-pagination',
          clickable: true,
        } : false,
        navigation: this['navigation'] ? {
          nextEl: this['navigation-class'] ? `.${this['navigation-class']}-next` : '.swiper-button-next',
          prevEl: this['navigation-class'] ? `.${this['navigation-class']}-prev` : '.swiper-button-prev',
        } : false,
        scrollbar: this['scrollbar'] ? {
          el: ".swiper-scrollbar",
          hide: true,
        } : false,
        breakpoints: this['breakpoints'] ? this['breakpoints'] : false,
        on: {
          init: e => {
            if (e.passedParams.loop) {
              let num = this.getCurrentSlidesPerView;
              let sliderLength = e.slides.length;

              if (this['centered-slides']) {
                num += 2;
              }

              if (sliderLength <= num) {
                for (let index = 1; index < Math.ceil(num / sliderLength); index++) {
                  e.slides.forEach((slide) => {
                    const clonedElement = slide.cloneNode(true);
                    e.slidesEl.appendChild(clonedElement);
                  })
                }

                setTimeout(() => {
                  let $bullets = this.querySelectorAll('.swiper-pagination-bullet');
                  $bullets.forEach((bullet, index) => {
                    if (index >= sliderLength) {
                      bullet.style.display = 'none';
                    }
                  })
                }, 250)
              }
            }
          }
        }
      })
    }
  }
  if (!window.customElements.get('yg-swiper')) {
    window.customElements.define('yg-swiper', YGSwiper)
  }

  class YGMegaMenuProduct extends HTMLElement {
    constructor() {
      super()
      this.itemClick = this.itemClick.bind(this);

      this.$tabTitleList = this.tabTitleList;
      this.$tabContentList = this.tabContentList;
    }

    get tabContentList () {
      if (!this.$tabContentList) {
        this.$tabContentList = this.querySelectorAll('.yg-right-row')
      }

      return this.$tabContentList
    }

    get tabTitleList () {
      if (!this.$tabTitleList) {
        this.$tabTitleList = this.querySelectorAll('.yg-left-row-item')
      }

      return this.$tabTitleList
    }

    connectedCallback () {
      this.$tabTitleList.forEach((item, i) => {
        item.addEventListener('mouseover', (e) => this.itemClick(e, i));
      })
    }
    disconnectedCallback () {
      this.$tabTitleList.forEach((item, i) => {
        item.removeEventListener('mouseover', (e) => this.itemClick(e, i));
      })
    }

    itemClick (e, i) {
      // 这里放置自定义逻辑
      this.$tabTitleList.forEach(($tabTitle) => {
        $tabTitle.classList.remove('active')
      })
      this.$tabContentList.forEach(($tabContent) => {
        $tabContent.classList.remove('active')
      })
      this.$tabTitleList[i].classList.add('active')
      this.$tabContentList[i].classList.add('active')
    }
  }
  if (!window.customElements.get('yg-mega-menu-tab')) {
    window.customElements.define('yg-mega-menu-tab', YGMegaMenuProduct)
  }
  class YGRichtext extends HTMLElement {
    constructor() {
      super()
      this.$btnList = this.btnList
      this.$itemList = this.itemList
      this.$headerList = this.headerList
    }
    get btnList () {
      if (!this.$btnList) {
        this.$btnList = this.querySelectorAll('.yg-richtext__icon')
      }
      return this.$btnList
    }
    get itemList () {
      if (!this.$itemList) {
        this.$itemList = this.querySelectorAll('.yg-richtext__content')
      }
      return this.$itemList
    }
    get headerList () {
      if (!this.$headerList) {
        this.$headerList = this.querySelectorAll('.yg-richtext__header')
      }
      return this.$headerList
    }

    handClick (e, i) {
      if (this.$itemList[i].classList.contains('active')) {
        this.$itemList[i].classList.remove('active')
        this.$btnList[i].classList.remove('active')
        this.$itemList[i].style.maxHeight = 0 + 'px'
      } else {
        const height =this.$itemList[i].scrollHeight
        this.$itemList[i].classList.add('active')
        this.$itemList[i].style.maxHeight = height + 'px'
        this.$btnList[i].classList.add('active')
      }
    }
    connectedCallback () {
      this.$headerList.forEach(($item, i) => $item.addEventListener('click', (e) => this.handClick(e, i)))
    }

  }
  if (!window.customElements.get('yg-richtext')) {
    window.customElements.define('yg-richtext', YGRichtext)
  }
  class YGAddToCartButton extends HTMLElement {
      connectedCallback() {
        const button = this.querySelector('button.yg-add-to-cart');
        const submitBtn = document.querySelector('.product-info__buy-buttons button.yg-add-to-cart');

        if (button && submitBtn) {
          button.addEventListener('click', (e) => {
            e.preventDefault();
            submitBtn.click();
          });
        }
      }
    }
    customElements.define('yg-add-to-cart-button', YGAddToCartButton);
})
